import gql from 'graphql-tag';
import {Job} from '@/core/entity';

export interface TaskSummary {
  id: string;
  date: string;
  count: number;
}

export const getTaskSummary = gql`
  query($year: Int!, $month: Int!) {
    summary: taskSummary(year: $year, month: $month) {
      id
      date
      count
    }
  }
`;

export interface Project {
  id: string;
  name: string;
}

export interface Task {
  id: string;
  auditor: {
    id: string;
    name: string;
  };
  entries: Array<{ id: string }>;
  outlet: {
    id: string;
    name: string;
    retailer: {
      id: string;
      logo: {
        id: string;
        url: string;
      };
    };
  };
  jobs: Job[];
  projects: Project[];
}

export const listTask = gql`
  query($date: String!) {
    tasks: listTask(date: $date) {
      id
      auditor {
        id
        name
      }
      entries {
        id
      }
      outlet {
        id
        name
        retailer {
          id
          logo {
            id
            url
          }
        }
      }
      jobs {
        id
        client {
            name
        }
        description
      }
      projects {
        id
        name
      }
    }
  }
`;
